import { http } from '@/api/http';
import { PaginatedApiResponseBody } from '@/api/types';
import { Hospital } from '@/api/apis/facilities';
import { getOpobffHospitalApiUrl } from './opobff-hospital.paths';
import { PaginatedOpobffHospitalListQueryParams } from './opobff-hospital.types';

const getHospitalList = async (params: PaginatedOpobffHospitalListQueryParams) => {
  const res = await http.get<PaginatedApiResponseBody<Hospital>>(getOpobffHospitalApiUrl.hospitals(), { params });
  return res.data.data;
};

export const opobffHospitalApiFetcher = {
  getHospitalList,
};
